export var ACTION;
(function (ACTION) {
    ACTION["CONTINUE_ACTION"] = "CONTINUE_ACTION";
    ACTION["AGREEMENT_ACTION"] = "AGREEMENT_ACTION";
    ACTION["OPEN_TAB"] = "OPEN_TAB";
    ACTION["VERIFICATION_SUCCESS"] = "VERIFICATION_SUCCESS";
    ACTION["BACK_ACTION"] = "BACK_ACTION";
    ACTION["GO_BACK"] = "GO_BACK";
    ACTION["KFS_SUCCESS"] = "KFS_SUCCESS";
    ACTION["KFS_CANCEL"] = "KFS_CANCEL";
    ACTION["GO_TO_AGREEMENT_PAGE"] = "GO_TO_AGREEMENT_PAGE";
    ACTION["CLOSE_FAILURE_CARD"] = "CLOSE_FAILURE_CARD";
})(ACTION || (ACTION = {}));
